import React from "react";
import join5 from "../../../assets/join5.png";

export default function JoinPhaseFive() {
  return (
    <div className="flex flex-col gap-4 justify-center items-center">
      <img src={join5} alt="" />
      <p className="text-center text-[16px]">
        Get visibility through extensive digital and print media coverage,
        amplifying your presence and showcasing your innovation.
      </p>
    </div>
  );
}
